export default __webpack_public_path__ + "static/media/vines2.8e8930bf.png";